export const stateValidator = {
    methods: {
        $_redirectIfFail() {
            //debugger
            // validate route params
            let notFound = false

            if (this.$route.name === 'features') {
                if (this.reel) {
                    this.$router.push({
                        name: 'featured-reel',
                        params: {reel: this.reel.slug}
                    })
                }
            } else if (this.$route.name === 'featured-reel') {
                if (!this.reel) {
                    this.$router.push({name: 'featured'})
                }
            } else if (this.$route.name === 'featured-detail') {
                if (!this.reel) {
                    this.$router.push({name: 'featured'})
                } else if (!this.media) {
                    this.$router.push({
                        name: 'featured-reel',
                        params: {reel: this.reel.slug}
                    })
                }
            }

            if (notFound) {
                this.$router.push({name: 'home'})
            }
        }
    }
}
